import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { triggerTransition } from '@uirouter/redux';
import Translation from "../../../../shared/Translation";

class BackToListing extends Component {
    constructor(props){
        super(props);
        this.escFunction = this.escFunction.bind(this);
    }
    escFunction(event){
        if(event.key === "Escape") {
            this.goBack(event);
        }
    }
    componentDidMount(){
        document.addEventListener("keydown", this.escFunction, false);
    }
    componentWillUnmount(){
        document.removeEventListener("keydown", this.escFunction, false);
    }
    render() {
        const iconClass = this.props.isEmbed ? 'icon-close' : 'icon-arrow_back';
        const slug = this.props.isEmbed ? 'checkout__close' : 'checkout__back_to_listing';
        return (
            
            <div className='confirmation__nav'>
                <button className='button--link' onClick={this.goBack}><i className={iconClass} aria-hidden="true"></i> <Translation>{slug}</Translation></button>
            </div>
        )
    }

    goBack = (e) => {
        e.preventDefault();
        if(this.props.queueOn === true) {
            setTimeout(() => {
              localStorage.clear();
              if (this.props.isEmbed) {
                parent.location.reload();
              } else {
                window.location.reload();
              }
            }, 0);
        }
        this.props.triggerTransition('ticketPicker');
    }
}

BackToListing.propTypes = {
    queueOn: PropTypes.bool,
}

const mapStateToProps = state => {
    return {
        isEmbed: !!state?.ui?.isEmbed,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        triggerTransition,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BackToListing)
